import { styled, styledForMobile } from "@l2r-front/l2r-ui"

export const Wrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
})
export const ChartContainer = styled("div")({
    flex: "1 1 auto",
    height: "100%",
    width: "100%",
})

export const LegendsWrapper = styledForMobile("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(6),
}))

export const LegendWrapper = styled("div")(() => ({
    display: "flex",
}))

export const Color = styled("div")(({ color, theme }) => ({
    backgroundColor: color,
    borderRadius: 4,
    height: 20,
    marginRight: theme.spacing(2),
    width: 20,
}))
